import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { IOuter } from '../EmptyState.types';

export const NetworkErrorTitle: FC<IOuter> = () => <FormattedMessage id="empty-state.network-error-title" />;
